import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { NoDataLandscape } from "pro-features/components/NoData/src/NoData";

import type { ConfigSchema, SearchPieChartData, SearchRankPositionData, SearchTrafficData } from "../../types";
import SearchCardHeader from "../SearchCardHeader/SearchCardHeader";

import { Container, NoDataWrapper } from "./styledComponents";

type WidgetSchema = {
    data: SearchTrafficData | SearchPieChartData | SearchRankPositionData;
    isLoading: boolean;
    isError: boolean;
    isKeywordsLoading: boolean;
    withBorder?: boolean;
};

const SearchCardWidget = ({
    title,
    iconButtonHref,
    name,
    tooltipText,
    component,
    data,
    isKeywordsLoading,
    isLoading,
    isError,
    withBorder,
    descriptionText,
    noDataStateOnError,
    styles,
}: ConfigSchema & WidgetSchema) => {
    const WidgetComponent = component;

    return (
        <Container
            style={styles}
            withBorder={withBorder}
            data-automation-item={`search-widget-${name}`}
        >
            <SearchCardHeader
                tooltipText={tooltipText}
                title={title}
                iconButtonHref={iconButtonHref}
            />
            {isLoading ? (
                <PixelPlaceholderLoader
                    height={164}
                    width="100%"
                />
            ) : isError ? (
                <NoDataWrapper>
                    <NoDataLandscape
                        title={null}
                        // @ts-expect-error Type 'Element' is not assignable to type 'string'
                        subtitle={noDataStateOnError}
                    />
                </NoDataWrapper>
            ) : (
                <WidgetComponent
                    data={data}
                    descriptionText={descriptionText}
                    isKeywordsLoading={isKeywordsLoading}
                />
            )}
        </Container>
    );
};

export default SearchCardWidget;
